import { Col, Divider, Empty, Image, Modal, Row } from "antd";
import { getPhotoUrl } from "utils/common";

export default function DeliveryPhotosModal({
  visible,
  onClose,
  pickupPhotos = [],
  deliveryPhotos = [],
}) {
  const renderPhotos = (photos, title) => (
    <>
      <Divider orientation="left">{title}</Divider>
      {photos && photos.length > 0 ? (
        <Row gutter={[16, 16]}>
          {photos.map((photo, index) => (
            <Col key={photo._id || index} xs={12} sm={8} md={6}>
              <Image
                width="100%"
                height={120}
                style={{ objectFit: "cover", borderRadius: 8 }}
                src={getPhotoUrl(photo?.path || null)}
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYzN"
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty
          description={`Không có ${title.toLowerCase()}`}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </>
  );

  return (
    <Modal
      title="Hình ảnh lấy hàng và giao hàng"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {renderPhotos(pickupPhotos, "Hình ảnh lấy hàng")}
      {renderPhotos(deliveryPhotos, "Hình ảnh giao hàng")}
    </Modal>
  );
}
